module.exports = __webpack_public_path__ + "static/media/check.9bbdd94b.svg";